export const vkbTermsAndConditions = `<div class="selected-collections w-full rounded-lg">
      <div class="w-full h-full">
        <p class="font-bold text-[#F80A03] mt-4">ZU BEACHTEN FÜR ALLE NUTZER*INNEN: Hinweise zu den Nutzungsrechten</p>
        <ol class="list-decimal">
          <li class="mt-4 ml-8">
            <span class="font-bold">Urheberrechte:</span>
            <p>An allen Medien bestehen Urheber- und/oder Leistungsschutzrechte.</p>
          </li>
          <li class="mt-4 ml-8">
            <span class="font-bold">Nutzungsrechte:</span>
            <p>
              Der Konzern Versicherungskammer besitzt Nutzungsrechte und gestattet Ihnen die Verwendung ausschließlich im <span class="underline">dienstlichen Umfeld</span>. Die private Nutzung ist
              untersagt.
            </p>
          </li>
          <li class="mt-4 ml-8">
            <span class="font-bold">Nutzungsumfang:</span>
            <p>Sie sind dazu <span class="underline">verpflichtet</span>, bei jedem Asset die hinterlegten, ggf. beschränkten Nutzungsrechte (Gültigkeit, Exklusivität, Lizenzregion) zu beachten.</p>
          </li>
          <li class="mt-4 ml-8">
            <span class="font-bold">Ablauf von Nutzungsrechten:</span>
            <p>
              Assets mit <span class="underline">zeitlich begrenzten Nutzungsrechten</span>, die Sie in Verwendung haben (z.B. Einsatz auf Homepage), müssen von Ihnen
              <span class="underline text-[#F80A03]">rechtzeitig und eigenverantwortlich</span> nach Ablauf der Nutzungsrechte aus allen Medien entfernt und ggf. ins Archiv geschoben werden.
            </p>
          </li>
          <li class="mt-4 ml-8">
            <span class="font-bold">Verstöße:</span>
            <p>Nicht erlaubte Verwendung kann für den Konzern zu Vertragsstrafen sowie Unterlassungs- und Schadensersatzansprüchen führen.</p>
          </li>
          <li class="mt-4 ml-8">
            <span class="font-bold">Testsiegel:</span>
            <p>
              Testsiegel sind meist zeitlich begrenzt gültig. Vergewissern Sie sich daher <span class="underline">eigenverantwortlich</span> vor jeder Verwendung durch einen Abgleich mit der
              Mediendatenbank, dass Sie ein zum Zeitpunkt der Nutzung noch gültiges Siegel verwenden. Die Verwendung ungültiger Siegel kann ebenfalls
              <span class="underline">rechtliche Folgen</span> haben.
            </p>
          </li>
        </ol>
        <p class="font-bold mt-8">Ich verpflichte mich zur Einhaltung der Nutzungsrechte.</p>
      </div>
    </div>`;
